//  @flow

import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import type { State } from 'types/redux';
import { injectIntl } from 'react-intl';

// Components
import PromoCode from './PromoCode';

// Actions
import {
  getFirstPromotion,
  setActivePromotion
} from 'store/reducers/promotions/actions';

// Selectors
import { getVehicle } from 'store/reducers/appointment/selectors';

const mapStateToProps = (state: State) => ({
  vehicle: getVehicle(state)
});

export default compose(
  withRouter,
  injectIntl,
  connect(
    mapStateToProps,
    {
      getFirstPromotion,
      setActivePromotion
    }
  )
)(PromoCode);



// WEBPACK FOOTER //
// ./src/components/pages/ReviewPage/components/PromoCode/PromoCodeContainer.js